import React from 'react';
import { createBrowserRouter } from 'react-router-dom';
import Layout from './pages/business/Layout.jsx';
import IndexPage from './pages/IndexPage.jsx';
import LogoutPage from './pages/LogoutPage.jsx';
import BusinessIndexPage from './pages/business/BusinessIndexPage.jsx';
import FormsIndexPage from './pages/business/FormsIndexPage.jsx';
import FormEditPage from './pages/business/FormEditPage.jsx';
import BookingLinksPage from './pages/business/BookingLinksPage.jsx';
import ReportsIndexPage from './pages/business/ReportsIndexPage';
import ClientsIndexPage from './pages/business/ClientsIndexPage.jsx';
import MarketingIndexPage from './pages/business/MarketingIndexPage.jsx';
import MarketingEditAutomationPage from './pages/business/MarketingEditAutomationPage.jsx';
import InsightsIndexPage from './pages/business/InsightsIndexPage.jsx';
import SettingsPage from './pages/business/SettingsPage.jsx';
import CalendarPage from './pages/business/CalendarPage.jsx';
import EventTypesPage from './pages/business/scheduling/EventTypesPage.jsx';
import AvailabilityPage from './pages/business/scheduling/AvailabilityPage.jsx';
import SchedulingPagesPage from './pages/business/scheduling/SchedulingPagesPage.jsx';
import EventTypeEditPage from './pages/business/scheduling/EventTypeEditPage.jsx';
import IntegrationsPage from './pages/business/IntegrationsPage.jsx';
import GoogleOAuthCallback from './pages/business/integrations/GoogleOAuthCallback.jsx';
import Office365OAuthCallback from './pages/business/integrations/Office365OAuthCallback.jsx';
import JoinPage from './pages/JoinPage.jsx';
import AdminPage from './pages/AdminPage.jsx';
import StripeReturnPage from './pages/business/integrations/StripeReturnPage.jsx';
import PaymentsReturnPage from './public/pages/PaymentsReturnPage.jsx';
import ErrorPage from './pages/ErrorPage.jsx';
import ZoomOAuthCallback from './components/integrations/ZoomOAuthCallback.jsx';
import PackagesIndexPage from './pages/business/packages/PackagesIndexPage.jsx';
import PackageEditPage from './pages/business/packages/PackageEditPage.jsx';
import RedirectCurrentPage from './pages/business/RedirectCurrentPage.jsx';
import ReportEditPage from './pages/business/ReportEditPage';
import SquareOAuthCallback from '~/components/integrations/SquareOAuthCallback.jsx';
import TestPage from '~/pages/TestPage';
import SubscriptionsIndexPage from '~/pages/business/packages/SubscriptionsIndexPage';
import SubscriptionEditPage from '~/pages/business/packages/SubscriptionEditPage';
import CouponsIndexPage from '~/pages/business/coupons/CouponsIndexPage';
import CustomQuestionsIndexPage from '~/pages/business/customquestions/CustomQuestionsIndexPage';
import CustomQuestionEditPage from '~/pages/business/customquestions/CustomQuestionEditPage';
import CouponEditPage from '~/pages/business/coupons/CouponEditPage';
import Waitlist from '~/pages/business/scheduling/Waitlist';
import StripeOAuthCallback from '~/components/integrations/StripeOAuthCallback';
import GiftCertificatesIndexPage from '~/pages/business/packages/GiftCertificatesIndexPage';
import InvoicesIndexPage from '~/pages/business/packages/InvoicesIndexPage';
import InvoiceEditPage from '~/pages/business/packages/InvoiceEditPage';
import ClonePage from '~/pages/ClonePage.jsx';
import AdminBackgroundTasks from '~/pages/AdminBackgroundTasks.jsx';
import ReferralsPage from '~/pages/ReferralsPage.jsx';
import MarkHipaa from '~/pages/business/MarkHipaa.jsx';
import AssistantFormEdit from '~/components/assistant/AssistantFormEdit.jsx';
import ApplyThemePage, {
    ApplyThemeRedirect,
} from '~/pages/business/ApplyThemePage.jsx';

const router = createBrowserRouter([
    {
        path: '/',
        element: <IndexPage />,
        errorElement: <ErrorPage />,
    },
    {
        path: '/test',
        element: <TestPage />,
        errorElement: <ErrorPage />,
    },
    {
        path: '/login',
        element: <IndexPage />,
        errorElement: <ErrorPage />,
    },
    {
        path: '/logout',
        element: <LogoutPage />,
        errorElement: <ErrorPage />,
    },
    {
        path: '/current/*',
        element: <RedirectCurrentPage />,
    },
    {
        // Linked from the theme gallery on the marketing site
        path: '/themes/:themeId/apply',
        element: <ApplyThemeRedirect />,
        errorElement: <ErrorPage />,
    },
    {
        path: '/clone/:id/:token',
        element: <ClonePage />,
        errorElement: <ErrorPage />,
    },
    {
        path: '/business/:businessId/join/:token',
        element: <JoinPage />,
        errorElement: <ErrorPage />,
    },
    {
        path: '/admin/tasks',
        element: <AdminBackgroundTasks />,
        errorElement: <ErrorPage />,
    },
    {
        path: '/admin/tasks/:taskId',
        element: <AdminBackgroundTasks />,
        errorElement: <ErrorPage />,
    },
    {
        path: '/admin/:action/:id',
        element: <AdminPage />,
        errorElement: <ErrorPage />,
    },
    {
        path: '/business/:businessId',
        element: <Layout />,
        errorElement: <ErrorPage />,
        children: [
            {
                path: '/business/:businessId/referrals',
                element: <ReferralsPage />,
                errorElement: <ErrorPage />,
            },
            {
                path: '/business/:businessId/',
                element: <BusinessIndexPage />,
            },
            {
                path: '/business/:businessId/settings',
                element: <SettingsPage />,
            },
            {
                path: '/business/:businessId/settings/datetime',
                element: <SettingsPage initalTab="datetime" />,
            },
            {
                path: '/business/:businessId/settings/users',
                element: <SettingsPage initalTab="users" />,
            },
            {
                path: '/business/:businessId/settings/billing',
                element: <SettingsPage initalTab="billing" />,
            },
            {
                path: '/business/:businessId/settings/customfields',
                element: <SettingsPage initalTab="customfields" />,
            },
            {
                path: '/business/:businessId/settings/referral',
                element: <SettingsPage initalTab="referral" />,
            },
            {
                path: '/business/:businessId/forms',
                element: <FormsIndexPage />,
            },
            {
                path: '/business/:businessId/themes/:themeId/apply',
                element: <ApplyThemePage />,
            },
            {
                path: '/business/:businessId/booking-links',
                element: <BookingLinksPage />,
            },
            {
                path: '/business/:businessId/forms/:formId',
                element: <FormEditPage />,
            },
            {
                path: '/business/:businessId/forms/:formId/share',
                element: <FormEditPage initialTab="share" />,
            },
            {
                path: '/business/:businessId/forms/:formId/automations',
                element: <FormEditPage initialTab="automations" />,
            },
            {
                path: '/business/:businessId/assistant/forms',
                element: <AssistantFormEdit />,
            },
            {
                path: '/business/:businessId/reports',
                element: <ReportsIndexPage />,
            },
            {
                path: '/business/:businessId/reports/:reportId',
                element: <ReportEditPage />,
            },
            {
                path: '/business/:businessId/marketing',
                element: <MarketingIndexPage />,
            },
            {
                path: '/business/:businessId/marketing/:id',
                element: <MarketingEditAutomationPage />,
            },
            {
                path: '/business/:businessId/insights',
                element: <InsightsIndexPage />,
            },
            {
                path: '/business/:businessId/clients',
                element: <ClientsIndexPage />,
            },
            {
                path: '/business/:businessId/calendar',
                element: <CalendarPage />,
            },
            {
                path: '/business/:businessId/scheduling/event-types',
                element: <EventTypesPage />,
            },
            {
                path: '/business/:businessId/scheduling/event-types/:typeId',
                element: <EventTypeEditPage />,
            },
            {
                path: '/business/:businessId/scheduling/availability',
                element: <AvailabilityPage />,
            },
            {
                path: '/business/:businessId/scheduling/pages',
                element: <SchedulingPagesPage />,
            },
            {
                path: '/business/:businessId/scheduling/pages/automations',
                element: (
                    <SchedulingPagesPage
                        initialTab="automations"
                        key="automations"
                    />
                ),
            },
            {
                path: '/business/:businessId/scheduling/pages/share',
                element: <SchedulingPagesPage initialTab="share" key="share" />,
            },
            {
                path: '/business/:businessId/integrations',
                element: <IntegrationsPage />,
            },
            {
                path: '/business/:businessId/integrations/syncing',
                element: (
                    <IntegrationsPage initialTab="syncing" key="syncing" />
                ),
            },
            {
                path: '/business/:businessId/integrations/payments',
                element: (
                    <IntegrationsPage initialTab="payments" key="payments" />
                ),
            },
            {
                path: '/business/:businessId/integrations/other',
                element: <IntegrationsPage initialTab="other" key="other" />,
            },
            {
                path: '/business/:businessId/packages',
                element: <PackagesIndexPage />,
            },
            {
                path: '/business/:businessId/packages/:packageId',
                element: <PackageEditPage />,
            },
            {
                path: '/business/:businessId/packages/:packageId/clients',
                element: <PackageEditPage initialTab="clients" />,
            },
            {
                path: '/business/:businessId/subscriptions',
                element: <SubscriptionsIndexPage />,
            },
            {
                path: '/business/:businessId/subscriptions/:packageId',
                element: <SubscriptionEditPage />,
            },
            {
                path: '/business/:businessId/subscriptions/:packageId/clients',
                element: <SubscriptionEditPage initialTab="clients" />,
            },
            {
                path: '/business/:businessId/coupons',
                element: <CouponsIndexPage />,
            },
            {
                path: '/business/:businessId/coupons/:couponId',
                element: <CouponEditPage />,
            },
            {
                path: '/business/:businessId/custom-questions',
                element: <CustomQuestionsIndexPage />,
            },
            {
                path: '/business/:businessId/custom-questions/:customQuestionId',
                element: <CustomQuestionEditPage />,
            },
            {
                path: '/business/:businessId/waitlist',
                element: <Waitlist />,
            },
            {
                path: '/business/:businessId/gift-certificates',
                element: <GiftCertificatesIndexPage />,
            },
            {
                path: '/business/:businessId/invoices',
                element: <InvoicesIndexPage />,
            },
            {
                path: '/business/:businessId/invoices/:invoiceId',
                element: <InvoiceEditPage />,
            },
            {
                path: '/business/:businessId/mark-hipaa',
                element: <MarkHipaa />,
            },
        ],
    },
    {
        path: '/calendars/google/oauth',
        element: <GoogleOAuthCallback />,
    },
    {
        path: '/calendars/office365/callback',
        element: <Office365OAuthCallback />,
    },
    {
        path: '/integrations/zoom/callback',
        element: <ZoomOAuthCallback />,
    },
    {
        path: '/integrations/square/callback',
        element: <SquareOAuthCallback />,
    },
    {
        path: '/integrations/stripe/callback',
        element: <StripeOAuthCallback />,
    },
    {
        path: '/integrations/payments/stripe/return/:businessId',
        element: <StripeReturnPage />,
    },
    {
        path: '/payments/return/:businessId/:type/:id',
        element: <PaymentsReturnPage />,
    },
]);

export { router };
